import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import { LatestMovies, HotRanking } from '@/pages/home/components/MovieSections';
import NewsPreview from '@/pages/home/components/NewsPreview';
import IntroBand from '@/pages/home/components/IntroBand';
import { useSeo } from '@/hooks/useSeo';

export default function Home() {
  useSeo({
    title: '日韩成人电影 - 最新成人影片推荐与资讯网站',
    description:
      '日韩成人电影提供丰富的最新日韩成人影视资讯和影片介绍，覆盖多种成人电影类别，为用户带来全面的影视内容浏览体验。',
    keywords: '日韩成人电影,成人电影,日韩成人影视,成人影片推荐,成人电影资讯,影视内容,日韩电影',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20elegant%20woman%20in%20a%20deep%20burgundy%20coat%20standing%20beside%20a%20rain%20covered%20window%20in%20a%20dim%20Tokyo%20apartment%20at%20night%2C%20red%20neon%20reflections%20on%20wet%20glass%2C%20moody%20film%20noir%20lighting%2C%20warm%20amber%20lamp%20glow%2C%20tasteful%20fully%20clothed%20editorial%20film%20photography%2C%20shallow%20depth%20of%20field%2C%2035mm%20grain&width=1600&height=900&seq=hero-rain-night-01&orientation=landscape',
  });

  return (
    <>
      <HeroCarousel />
      <CategoryGrid />
      <LatestMovies />
      <HotRanking />
      <NewsPreview />
      <IntroBand />
    </>
  );
}